import {
    fetchAllFormEntries,
    fetchFormsForAutocomplete,
    getFormEntry,
    isEmpty,
    toSelectOptions,
    toStr,
} from "@rpforms/shared";
import {
    createOfferFromForms,
    IFormPayload,
    isTurListeFormName,
    parseSchemaFields,
} from "@rpforms/shared/build/utilities";
import * as actions from "@rpforms/shared/build/actions/formEntries";
import { user } from "@rpforms/shared/build/actions/actions_helper";
import { fetchFormEntryPdfUrl, openSignedUrl } from "@rpforms/shared/build/actions/signedDownloads";
import { Content } from "@rpforms/shared/build/components/layout/Content";
import { EmptySpace } from "@rpforms/shared/build/components/universal/EmptySpace";
import { Loader } from "@rpforms/shared/build/components/universal/Loader";
import PageNavAction from "@rpforms/shared/build/components/universal/PageNavAction";
import PageNavbar from "@rpforms/shared/build/components/universal/PageNavbar";
import { range } from "@rpforms/shared/build/utils";
import axios from "axios";
import { push } from "connected-react-router";
import React, { useEffect, useState } from "react";
import {
    Alert,
    Button,
    Col,
    Container,
    Dropdown,
    Form,
    Modal,
    Pagination,
    Row,
} from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { useSearchParam } from "react-use";
import styled from "styled-components";
import { API_URL, COMPANY_ID } from "../../config";
import { CustomerFilter } from "../../components/entries/CustomerFilter";
import { DeviceFilter } from "../../components/entries/DeviceFilter";
import { EntityFilter } from "../../components/entries/EntityFilter";
import EntryRow from "../../components/entries/EntryRow";
import { FormFilter } from "../../components/entries/FormFilter";
import NotificationsFilter from "../../components/entries/NotificationsFilter";
import { StateFilter } from "../../components/entries/StateFilter";
import { RootState } from "../../reducers";

const Centered = styled.div`
    display: flex;
    justify-content: center;
`;

const AllEntriesPage = () => {
    const formEntries = useSelector<RootState, any>((rootState) => rootState.formEntries);
    const entitiesDB = useSelector<RootState, any>((rootState) => rootState.entities);
    const [formsDB, setFormsDB] = useState([]);
    const [showInventoryNotesModal, setShowInventoryNotesModal] = useState(false);

    const [inventoryNotesByEntry, setInventoryNotesByEntry] = useState<
        Array<{ entryId: number; entryName: string; formName: string; notes: string[] }>
    >([]);
    const [pendingOfferQuery, setPendingOfferQuery] = useState<string | null>(null);

    const pageParam = useSearchParam("page");
    const pageSizeParam = useSearchParam("page_size");

    const idsParams = useSearchParam("ids");
    const fromParam = useSearchParam("from");
    const untilParam = useSearchParam("until");
    const devicesParam = useSearchParam("device_ids");
    const formParam = useSearchParam("form_ids");
    const stateParam = useSearchParam("states");
    const hasNotificationsParam = useSearchParam("has_notifications");
    const customerParam = useSearchParam("customer_ids");
    const entityParam = useSearchParam("entity_ids");

    const field = useSearchParam("field") || "";
    const fieldValue = useSearchParam("fieldValue") || null;
    const fieldComparator = useSearchParam("fieldComparator") || null;

    useEffect(() => {
        dispatch(
            fetchFormsForAutocomplete((data) => {
                setFormsDB(data);
            })
        );
    }, []);

    const getInitialParameter = (p, n, select = true) => {
        const sp = select ? toSelectOptions(toStr(p).split(",")) : p;
        if (!isEmpty(sp)) {
            return sp;
        }
        try {
            const ret = JSON.parse(sessionStorage.getItem(n));
            if (ret == null && ["form_entries.from", "form_entries.until"].includes(n)) {
                return "";
            }
            return ret;
        } catch (e) {
            if (["form_entries.from", "form_entries.until"].includes(n)) {
                return "";
            }
            return null;
        }
    };

    const setInitialParameter = (n, v) => {
        sessionStorage.setItem(n, JSON.stringify(v));
    };

    const unsetInitialParameters = () => {
        sessionStorage.removeItem("form_entries.from");
        sessionStorage.removeItem("form_entries.until");
        sessionStorage.removeItem("form_entries.devices");
        sessionStorage.removeItem("form_entries.forms");
        sessionStorage.removeItem("form_entries.has_notifications");
        sessionStorage.removeItem("form_entries.states");
        sessionStorage.removeItem("form_entries.customers");
        sessionStorage.removeItem("form_entries.entities");
    };

    const initialPageSize = parseInt(pageSizeParam, 10) || 10;
    const initialPage = parseInt(pageParam, 10) || 1;
    const [page, setPage] = useState(getInitialParameter(initialPage, "form_entries.page", false));
    const [pageSize, setPageSize] = useState(
        getInitialParameter(initialPageSize, "form_entries.page_size", false)
    );

    const [ids, setIds] = useState(getInitialParameter(idsParams, "form_entries.ids", false));
    const [from, setFrom] = useState(getInitialParameter(fromParam, "form_entries.from", false));
    const [until, setUntil] = useState(
        getInitialParameter(untilParam, "form_entries.until", false)
    );
    const [devices, setDevices] = useState(
        getInitialParameter(devicesParam, "form_entries.devices")
    );
    const [forms, setForms] = useState(getInitialParameter(formParam, "form_entries.forms"));
    const [states, setStates] = useState(getInitialParameter(stateParam, "form_entries.states"));
    const [hasNotifications, setHasNotifications] = useState(
        !!getInitialParameter(hasNotificationsParam, "form_entries.has_notifications", false)
    );
    const [customers, setCustomers] = useState(
        getInitialParameter(customerParam, "form_entries.customers")
    );
    const [entities, setEntities] = useState(
        getInitialParameter(entityParam, "form_entries.entities")
    );

    // Selection state for offer generation
    const [selectedEntryIds, setSelectedEntryIds] = useState<number[]>([]);
    const [selectedEntriesData, setSelectedEntriesData] = useState<Map<number, any>>(new Map());
    const [isGeneratingOffer, setIsGeneratingOffer] = useState(false);
    const [offerError, setOfferError] = useState<string | null>(null);

    const dispatch = useDispatch();
    const history = useHistory();

    const [currentUrl, setCurrentUrl] = useState("/entries");

    const [resetted, setResetted] = useState(false);

    useEffect(() => {
        if (resetted) {
            setResetted((prevState) => false);
            return;
        }
        const opts: any = {
            hidden_fields:
                "disposal_sales_price,disposal_sales_price_formatted,repair_sales_price,repair_sales_price_formatted,service_sales_price,service_sales_price_formatted,total_sales_price,total_sales_price_formatted,form_data,uploads,latest_revision_version,latest_revision_id",
        };
        let url = `/entries?page=${page}&page_size=${pageSize}`;
        if (ids && ids.length > 0) {
            const idsArr = ids.split(",").filter((x) => x != null);
            url += `&ids=${idsArr.join(",")}`;
            opts["q[id_in][]"] = idsArr;
        }
        if (from) {
            url += `&from=${from}`;
            opts["q[created_at_gteq]"] = from;
        }
        if (until) {
            url += `&from=${until}`;
            opts["q[created_at_lteq]"] = `${until} 23:59:59`;
        }
        if (devices && devices.length > 0) {
            const deviceIds = devices.map((d) => d.value);
            url += `&device_ids=${deviceIds.join(",")}`;
            if (deviceIds.length === 1 && deviceIds[0] === "-1") {
                opts["q[device_id_blank]"] = true;
            } else {
                opts["q[device_id_in][]"] = deviceIds;
            }
        }
        if (forms && forms.length > 0) {
            const formIds = forms.map((d) => d.value);
            url += `&form_ids=${formIds.join(",")}`;
            opts["q[form_id_in][]"] = formIds;
        }
        if (states && states.length > 0) {
            const stateIds = states.map((d) => d.value);
            url += `&states=${stateIds.join(",")}`;
            opts["state_in[]"] = stateIds;
        }
        if (customers && customers.length > 0) {
            const customerIds = customers.map((d) => d.value);
            url += `&customer_ids=${customerIds.join(",")}`;
            opts["q[customer_id_in][]"] = customerIds;
        }
        if (entities && entities.length > 0) {
            const entityIds = entities.map((d) => d.value);
            url += `&entity_ids=${entityIds.join(",")}`;
            opts["q[entity_id_in][]"] = entityIds;
        }
        if (hasNotifications) {
            url += `&has_notifications=${hasNotifications}`;
            opts.has_notifications = true;
        }
        if (field) {
            url += `&field=${field}`;
            opts.field = field;
            if (fieldValue) {
                url += `&fieldValue=${fieldValue}`;
                opts.fieldValue = fieldValue;
                if (!fieldComparator) {
                    url += `&fieldComparator=eq`;
                    opts.fieldComparator = "eq";
                }
            } else {
                if (!fieldComparator) {
                    url += `&fieldComparator=exists`;
                    opts.fieldComparator = "exists";
                }
            }
            if (fieldComparator) {
                url += `&fieldComparator=${fieldComparator}`;
                opts.fieldComparator = fieldComparator;
            }
        }
        if (currentUrl !== url) {
            setCurrentUrl(url);
            dispatch(push(url));
            dispatch(fetchAllFormEntries(page, () => {}, true, opts, pageSize));
        }
    }, [
        ids,
        page,
        pageSize,
        from,
        until,
        devices,
        forms,
        states,
        hasNotifications,
        customers,
        entities,
        resetted,
    ]);

    const openPage = (newPage) => {
        setPage(newPage);
    };

    const pages = () => {
        const pagesOffset = 5;
        return [1, ...range(Math.max(2, page - pagesOffset), page + pagesOffset)];
    };

    const resetFilter = () => {
        setResetted((prevState) => {
            unsetInitialParameters();
            setIds(null);
            setFrom("");
            setUntil("");
            setDevices(null);
            setForms(null);
            setHasNotifications(false);
            setStates(null);
            setCustomers(null);
            setEntities(null);
            return true;
        });
    };

    // Helper function to get form name/type from entry
    const getFormName = (entry: any): string => {
        return entry?.form?.name || entry?.form?.label || "";
    };

    const isTurListeForm = (formName: string): boolean => isTurListeFormName(formName);

    // Check if form is a Leistungsnachweis (00_Leistungsnachweis) — these can be turned
    // directly into a Rechnung, the other LV forms into an Angebot.
    const isLeistungsnachweisForm = (formName: string): boolean => {
        return formName.toLowerCase().includes("leistungsnachweis");
    };

    // Selection handlers for offer generation
    const handleSelectEntry = (entryId: number, isSelected: boolean, entry?: any) => {
        if (isSelected) {
            setSelectedEntryIds([...selectedEntryIds, entryId]);
            if (entry) {
                setSelectedEntriesData((prev) => {
                    const newMap = new Map(prev);
                    newMap.set(entryId, { formEntry: entry });
                    return newMap;
                });
            }
        } else {
            setSelectedEntryIds(selectedEntryIds.filter((id) => id !== entryId));
            setSelectedEntriesData((prev) => {
                const newMap = new Map(prev);
                newMap.delete(entryId);
                return newMap;
            });
            // Clear error when deselecting
            if (selectedEntryIds.length <= 1) {
                setOfferError(null);
            }
        }
    };

    const handleSelectAll = () => {
        const allIds = formEntries.list.map((entry) => entry.id);
        const allSelected = allIds.every((id) => selectedEntryIds.includes(id));

        if (allSelected) {
            // Deselect all
            setSelectedEntryIds([]);
            setSelectedEntriesData(new Map());
            setOfferError(null);
        } else {
            // Select all visible entries
            setSelectedEntryIds(allIds);

            // Cache all entry data
            setSelectedEntriesData((prev) => {
                const newMap = new Map(prev);
                formEntries.list.forEach((entry) => {
                    if (!newMap.has(entry.id)) {
                        newMap.set(entry.id, { formEntry: entry });
                    }
                });
                return newMap;
            });
        }
    };

    const handleGenerateDocument = async (target: "offer" | "invoice" = "offer") => {
        const docLabel = target === "invoice" ? "Rechnung" : "Angebot";

        if (selectedEntryIds.length === 0) {
            setOfferError("Bitte wählen Sie mindestens ein Formular aus");
            return;
        }

        if (target === "invoice") {
            // Validate that all selected entries are of the same form type
            const selectedForms = selectedEntryIds
                .map((id) => selectedEntriesData.get(id)?.formEntry)
                .filter(Boolean);
            const formNames = selectedForms.map((entry) => getFormName(entry));
            const uniqueFormNames = Array.from(new Set(formNames));

            if (uniqueFormNames.length > 1) {
                setOfferError(
                    `Nur Formulare vom gleichen Typ können für ein ${docLabel} verwendet werden. Gefundene Typen: ${uniqueFormNames.join(
                        ", "
                    )}`
                );
                return;
            }

            // Check if it's a Türliste form
            if (uniqueFormNames.length === 1 && isTurListeForm(uniqueFormNames[0])) {
                if (selectedEntryIds.length > 1) {
                    setOfferError(
                        `Für Türliste-Formulare kann nur ein Formular für ein ${docLabel} ausgewählt werden`
                    );
                    return;
                }
            }
        }

        // Clear any existing generated offer data to prevent spillover from previous sessions
        sessionStorage.removeItem("generated_offer_data");
        sessionStorage.removeItem("generated_offer_sources");

        setIsGeneratingOffer(true);
        setOfferError(null);

        try {
            console.log(
                "[Generate Offer] Starting offer generation for",
                selectedEntryIds.length,
                "entries"
            );

            // Fetch full form data for selected entries
            const formPayloads: IFormPayload[] = [];

            for (const entryId of selectedEntryIds) {
                console.log("[Generate Offer] Processing entry", entryId);
                // Check if we already have the data
                if (selectedEntriesData.has(entryId)) {
                    const entryData = selectedEntriesData.get(entryId);
                    // Validate cached data has formPayload with fields
                    if (entryData?.formPayload?.fields) {
                        console.log(
                            `[Generate Offer] Using cached data for entry ${entryId}, fields:`,
                            entryData.formPayload.fields.length
                        );
                        formPayloads.push({
                            ...entryData.formPayload,
                            entryName:
                                entryData.formPayload.entryName || entryData.formEntry?.name || "",
                        });
                        continue;
                    } else {
                        console.log(
                            `[Generate Offer] Cached data for entry ${entryId} missing formPayload, will fetch from API`
                        );
                    }
                }

                // Fetch from API
                await new Promise<void>((resolve, reject) => {
                    dispatch(
                        getFormEntry(entryId, (formEntry) => {
                            try {
                                console.log(
                                    `[Generate Offer] Entry ${entryId} data received:`,
                                    formEntry ? "OK" : "NULL"
                                );

                                if (!formEntry) {
                                    throw new Error(`Form entry ${entryId} not found in database`);
                                }

                                // Get schema from form_revision.form_data (contains field definitions)
                                let schemaFields = parseSchemaFields(
                                    formEntry?.form_revision?.form_data
                                );
                                if (schemaFields.length === 0) {
                                    schemaFields = parseSchemaFields(
                                        formEntry?.latest_revision?.form_data
                                    );
                                }
                                if (schemaFields.length === 0) {
                                    throw new Error(`Failed to parse schema for entry ${entryId}`);
                                }

                                // Get entry values from form_data (contains user input values)
                                let entryValues: any = formEntry?.form_data || {};
                                if (typeof entryValues === "string") {
                                    try {
                                        entryValues = JSON.parse(entryValues);
                                    } catch (e) {
                                        entryValues = {};
                                    }
                                }

                                // Apply entry values to schema fields recursively
                                const applyEntryValues = (fields = []) => {
                                    return fields.map((field) => {
                                        const nextField = { ...field };
                                        if (
                                            entryValues &&
                                            nextField?.hashCode &&
                                            Object.prototype.hasOwnProperty.call(
                                                entryValues,
                                                nextField.hashCode
                                            )
                                        ) {
                                            nextField.value = entryValues[nextField.hashCode];
                                        }
                                        if (
                                            nextField?.type === "InventoryItemSelectField" ||
                                            nextField?.type === "LeistungsV"
                                        ) {
                                            const notesKey = `${nextField.hashCode}__notes`;
                                            if (entryValues && entryValues[notesKey]) {
                                                nextField.notes = entryValues[notesKey];
                                            }
                                        }
                                        // Handle InventoryItemSelectTableRow inside TableField
                                        if (
                                            nextField?.type === "TableField" &&
                                            nextField.subfields
                                        ) {
                                            nextField.subfields = nextField.subfields.map(
                                                (subfield) => {
                                                    const nextSubfield = { ...subfield };
                                                    if (
                                                        nextSubfield?.type ===
                                                        "InventoryItemSelectTableRow"
                                                    ) {
                                                        const notesKey = `${nextSubfield.hashCode}__notes`;
                                                        if (entryValues && entryValues[notesKey]) {
                                                            nextSubfield.notes =
                                                                entryValues[notesKey];
                                                        }
                                                    }
                                                    return nextSubfield;
                                                }
                                            );
                                        }
                                        if (nextField.subfields && nextField.subfields.length > 0) {
                                            nextField.subfields = applyEntryValues(
                                                nextField.subfields
                                            );
                                        }
                                        return nextField;
                                    });
                                };

                                const formPayload: IFormPayload = {
                                    fields: applyEntryValues(schemaFields),
                                    form: {
                                        name: formEntry.form?.name || formEntry.form?.label || "",
                                        endpoint: "",
                                    },
                                    entryName: formEntry?.name || "",
                                };
                                formPayloads.push(formPayload);

                                // Cache the data
                                setSelectedEntriesData((prev) => {
                                    const newMap = new Map(prev);
                                    newMap.set(entryId, { formEntry, formPayload });
                                    return newMap;
                                });

                                resolve();
                            } catch (e) {
                                reject(e);
                            }
                        })
                    );
                });
            }

            // Generate offer data
            console.log(
                "[Generate Offer] Creating offer from",
                formPayloads.length,
                "form payloads"
            );

            if (formPayloads.length === 0) {
                throw new Error("No form data available to generate offer");
            }

            // Validate all payloads have required structure
            const invalidPayloads = formPayloads.filter((payload, idx) => {
                if (!payload) {
                    console.error(`[Generate Offer] Payload ${idx} is null/undefined`);
                    return true;
                }
                if (!Array.isArray(payload.fields)) {
                    console.error(`[Generate Offer] Payload ${idx} missing fields array:`, payload);
                    return true;
                }
                return false;
            });

            if (invalidPayloads.length > 0) {
                throw new Error(
                    `${invalidPayloads.length} form payload(s) are missing required data`
                );
            }

            console.log(
                "[Generate Offer] All payloads validated, calling createOfferFromForms with",
                formPayloads.length,
                "payloads"
            );

            let result;
            try {
                result = createOfferFromForms(formPayloads, {
                    defaultUnit: "repair",
                    defaultPrice: 0,
                    includeHintsInDescription: true,
                });
            } catch (createError) {
                console.error("[Generate Offer] createOfferFromForms failed:", createError);
                throw new Error(
                    `Failed to create offer: ${createError.message || "Unknown error"}`
                );
            }

            console.log(
                "[Generate Offer] Offer data generated:",
                result ? "OK" : "NULL",
                "Positions:",
                result?.offerData?.invoicePositions?.length || 0
            );

            let offerData = result.offerData;

            // Check for inventory notes and collect entry names that have them
            const entriesWithInventoryNotes: Array<{
                entryId: number;
                entryName: string;
                formName: string;
                notes: string[];
            }> = [];

            const extractInventoryNotes = (fields = [], notes: string[] = []) => {
                fields.forEach((field) => {
                    if (
                        field?.type === "InventoryItemSelectField" ||
                        field?.type === "LeistungsV"
                    ) {
                        if (typeof field.notes === "string" && field.notes.trim().length > 0) {
                            notes.push(field.notes.trim());
                        }
                    }
                    if (field?.type === "TableField" && field.value) {
                        try {
                            const tableData =
                                typeof field.value === "string"
                                    ? JSON.parse(field.value)
                                    : field.value;
                            if (Array.isArray(tableData)) {
                                tableData.forEach((row, rowIndex) => {
                                    if (!Array.isArray(row)) return;
                                    row.forEach((cell) => {
                                        if (
                                            typeof cell?.notes === "string" &&
                                            cell.notes.trim().length > 0
                                        ) {
                                            notes.push(
                                                `Zeile ${rowIndex + 1}: ${cell.notes.trim()}`
                                            );
                                        }
                                    });
                                });
                            }
                        } catch (e) {
                            // Failed to parse table data
                        }
                    }
                    if (field?.type !== "TableField" && Array.isArray(field?.subfields)) {
                        extractInventoryNotes(field.subfields, notes);
                    }
                });
                return notes;
            };

            // Map formPayloads back to their entry IDs to get entry names
            selectedEntryIds.forEach((entryId, index) => {
                const payload = formPayloads[index];
                if (!payload) return;

                const fields = payload.fields || [];
                const notes = extractInventoryNotes(fields);

                if (notes.length > 0) {
                    // Get the entry name from the cached data or form entries list
                    const entryData = selectedEntriesData.get(entryId);
                    const entry =
                        entryData?.formEntry || formEntries.list.find((e) => e.id === entryId);
                    const entryName = entry?.name || `Eintrag ${entryId}`;
                    const formName = payload.form?.name || "Unbekanntes Formular";

                    entriesWithInventoryNotes.push({ entryId, entryName, formName, notes });
                }
            });

            const hasInventoryNotes = entriesWithInventoryNotes.length > 0;
            const inventoryItemIds = Array.from(
                new Set(
                    (result.offerData?.invoicePositions || [])
                        .map((position) => position.inventory_item_id)
                        .map((id) => {
                            if (typeof id === "string") {
                                const parsed = parseInt(id, 10);
                                return Number.isFinite(parsed) ? parsed : null;
                            }
                            if (typeof id === "number" && Number.isFinite(id)) {
                                return id;
                            }
                            return null;
                        })
                        .filter((id): id is number => id !== null)
                )
            );

            if (inventoryItemIds.length > 0) {
                try {
                    const idsQuery = inventoryItemIds
                        .map((id) => `ids[]=${encodeURIComponent(String(id))}`)
                        .join("&");
                    const response = await axios.get(
                        `${API_URL}/companies/${COMPANY_ID}/inventory_items.json?${idsQuery}`,
                        {
                            headers: { authorization: user().token },
                        }
                    );
                    const inventoryItems = (response?.data?.inventory_items || []) as Array<any>;
                    const inventoryItemMap = new Map(inventoryItems.map((item) => [item.id, item]));

                    offerData = {
                        ...result.offerData,
                        invoicePositions: (result.offerData?.invoicePositions || []).map(
                            (position) => {
                                const inventoryId = position.inventory_item_id;
                                if (!inventoryId) {
                                    return position;
                                }

                                const normalizedId =
                                    typeof inventoryId === "string"
                                        ? parseInt(inventoryId, 10)
                                        : inventoryId;
                                const inventoryItem = inventoryItemMap.get(normalizedId) as any;
                                if (!inventoryItem) {
                                    return { ...position, inventory_item_missing: true };
                                }

                                return { ...position, inventory_item_missing: false };
                            }
                        ),
                    };
                } catch (e) {
                    console.error("Failed to fetch inventory item updates", e);
                }
            }

            // Store offer data in sessionStorage
            sessionStorage.setItem("generated_offer_data", JSON.stringify(offerData));
            sessionStorage.setItem("generated_offer_sources", JSON.stringify(selectedEntryIds));

            // Pull customer and entity from selected entries (fallback to filter state)
            const selectedEntries = selectedEntryIds
                .map((entryId) => {
                    const cached = selectedEntriesData.get(entryId)?.formEntry;
                    if (cached) {
                        return cached;
                    }
                    return formEntries.list.find((entry) => entry.id === entryId);
                })
                .filter(Boolean);

            const customerIds = Array.from(
                new Set(selectedEntries.map((entry) => entry.customer_id).filter((id) => !!id))
            );
            const entityIds = Array.from(
                new Set(selectedEntries.map((entry) => entry.entity_id).filter((id) => !!id))
            );

            let customer_id = customerIds.length === 1 ? customerIds[0] : null;
            let entity_id = entityIds.length === 1 ? entityIds[0] : null;

            const hasCustomerFilter = !isEmpty(customerParam);
            const hasEntityFilter = !isEmpty(entityParam);

            if (!customer_id && entity_id && Array.isArray(entitiesDB?.autocomplete)) {
                const entityMatch = entitiesDB.autocomplete.find(
                    (entity) => entity.id === entity_id
                );
                if (entityMatch?.customer_id) {
                    customer_id = entityMatch.customer_id;
                }
            }

            if (!customer_id && hasCustomerFilter) {
                customer_id =
                    Array.isArray(customers) && customers.length > 0 ? customers[0].value : null;
            }
            if (!entity_id && hasEntityFilter) {
                entity_id =
                    Array.isArray(entities) && entities.length > 0 ? entities[0].value : null;
            }

            // Find target document form ID (by name or label).
            // The prefill machinery is form-agnostic: buildOfferFormData injects the extracted
            // LV positions into whichever form is loaded — only the target form_id differs
            // between Angebot (000_Angebot) and Rechnung (000_Rechnung).
            const targetFormName = target === "invoice" ? "000_Rechnung" : "000_Angebot";
            const targetForm = formsDB.find(
                (f) => f.name === targetFormName || f.label === targetFormName
            );
            const targetFormId = targetForm ? targetForm.id : null;

            let query = `prefill=generated_offer`;
            if (targetFormId) query += `&form_id=${encodeURIComponent(targetFormId)}`;
            if (customer_id) query += `&customer_id=${encodeURIComponent(customer_id)}`;
            if (entity_id) query += `&entity_id=${encodeURIComponent(entity_id)}`;
            if (hasInventoryNotes) {
                setInventoryNotesByEntry(entriesWithInventoryNotes);
                setPendingOfferQuery(query);
                setShowInventoryNotesModal(true);
                return;
            }
            // Navigate to offer creation page with preselected form/customer/object
            console.log("[Generate Offer] Navigating to offer editor with query:", query);
            history.push(`/entries/editor?${query}`);
        } catch (err) {
            console.error("[Generate Document Error]", err);
            let errorMessage = `Fehler beim Generieren ${
                target === "invoice" ? "der Rechnung" : "des Angebots"
            }`;

            if (err instanceof Error) {
                errorMessage += `: ${err.message}`;
            } else if (typeof err === "string") {
                errorMessage += `: ${err}`;
            }

            // Add more context about what went wrong
            if (err?.message?.includes("parse") || err?.message?.includes("JSON")) {
                errorMessage =
                    "Fehler beim Verarbeiten der Formulardaten. Möglicherweise sind die Daten beschädigt.";
            } else if (err?.message?.includes("not found")) {
                errorMessage =
                    "Mindestens eines der ausgewählten Formulare konnte nicht gefunden werden.";
            } else if (err?.message?.includes("schema")) {
                errorMessage =
                    "Fehler beim Lesen des Formularschemas. Bitte versuchen Sie es erneut.";
            }

            setOfferError(errorMessage);
        } finally {
            setIsGeneratingOffer(false);
        }
    };

    return (
        <>
            <Modal
                show={showInventoryNotesModal}
                onHide={() => setShowInventoryNotesModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Hinweis</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Es gibt zusaetzliche Hinweise im Feld Leistungsverzeichnisauswahl. Bitte vor
                        dem Angebot prüfen.
                    </p>
                    {inventoryNotesByEntry.map((entry) => (
                        <div
                            key={`${entry.entryName}-${entry.formName}`}
                            style={{ marginBottom: "12px" }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between",
                                    gap: "12px",
                                }}
                            >
                                <strong style={{ minWidth: 0, overflowWrap: "anywhere" }}>
                                    {entry.entryName} ({entry.formName})
                                </strong>
                                <Button
                                    onClick={() =>
                                        openSignedUrl(fetchFormEntryPdfUrl(entry.entryId))
                                    }
                                    size="sm"
                                    variant="outline-primary"
                                    style={{ flexShrink: 0, whiteSpace: "nowrap" }}
                                >
                                    PDF in neuem Tab
                                </Button>
                            </div>
                            <ul style={{ marginTop: "6px" }}>
                                {entry.notes.map((note, index) => (
                                    <li key={`${entry.entryName}-${index}`}>{note}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={() => {
                            setShowInventoryNotesModal(false);
                            if (pendingOfferQuery) {
                                history.push(`/entries/editor?${pendingOfferQuery}`);
                            }
                        }}
                    >
                        Weiter
                    </Button>
                </Modal.Footer>
            </Modal>
            <PageNavbar
                title="Protokolle"
                description="Hier können Sie übertragene Formulare verwalten."
            >
                {!formEntries.isLoading && (
                    <>
                        <Container>
                            <Row
                                style={{
                                    alignItems: "flex-end",
                                    width: "600px",
                                }}
                            ></Row>
                        </Container>
                        {selectedEntryIds.length > 0 &&
                            (() => {
                                const selectedFormNames = Array.from(
                                    new Set(
                                        selectedEntryIds
                                            .map((id) =>
                                                getFormName(selectedEntriesData.get(id)?.formEntry)
                                            )
                                            .filter(Boolean)
                                    )
                                );
                                // Rechnung only when every selected entry is a Leistungsnachweis;
                                // Angebot for the remaining LV forms.
                                const allLeistungsnachweis =
                                    selectedFormNames.length > 0 &&
                                    selectedFormNames.every(isLeistungsnachweisForm);
                                const count = selectedEntryIds.length;
                                return (
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            variant="light"
                                            id="create-document-dropdown"
                                            disabled={isGeneratingOffer}
                                        >
                                            <i
                                                className="fa fa-fw fa-file-text"
                                                style={{ paddingRight: 4 }}
                                            />
                                            {isGeneratingOffer
                                                ? "Generiere..."
                                                : "Dokument erstellen"}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item
                                                onClick={() => handleGenerateDocument("offer")}
                                                disabled={allLeistungsnachweis}
                                                title={
                                                    allLeistungsnachweis
                                                        ? "Für Leistungsnachweise bitte Rechnung erstellen"
                                                        : undefined
                                                }
                                            >
                                                {`Angebot aus ${count} Formular${
                                                    count > 1 ? "en" : ""
                                                }`}
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={() => handleGenerateDocument("invoice")}
                                                disabled={!allLeistungsnachweis}
                                                title={
                                                    !allLeistungsnachweis
                                                        ? "Nur für Leistungsnachweise verfügbar"
                                                        : undefined
                                                }
                                            >
                                                {`Rechnung aus ${count} Leistungsnachweis${
                                                    count > 1 ? "en" : ""
                                                }`}
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                );
                            })()}
                        <PageNavAction
                            onClick={() => {
                                const offerForm = formsDB.find(
                                    (f) => f.name === "000_Angebot" || f.label === "000_Angebot"
                                );
                                if (!offerForm) {
                                    return;
                                }
                                const formValue = [{ value: offerForm.id, label: offerForm.name }];
                                const stateValue = [{ value: "accepted", label: "Akzeptiert" }];
                                setInitialParameter("form_entries.forms", formValue);
                                setForms(formValue);
                                setInitialParameter("form_entries.states", stateValue);
                                setStates(stateValue);
                            }}
                            primary={false}
                            icon="check"
                            title="Angebote Roland"
                        />
                        <PageNavAction
                            link="/entries/editor"
                            primary={true}
                            icon="plus"
                            title="Protokoll erstellen"
                        />
                    </>
                )}
            </PageNavbar>
            <div>
                {offerError && (
                    <Alert variant="danger" dismissible onClose={() => setOfferError(null)}>
                        {offerError}
                    </Alert>
                )}
                {selectedEntryIds.length > 0 && (
                    <Alert variant="info">
                        <strong>Ausgewählt:</strong> {selectedEntryIds.length} Formular
                        {selectedEntryIds.length > 1 ? "e" : ""}
                        {(() => {
                            const selectedForms = selectedEntryIds
                                .map(
                                    (id) =>
                                        selectedEntriesData.get(id)?.formEntry ||
                                        formEntries.list.find((e) => e.id === id)
                                )
                                .filter(Boolean);
                            const formNames = selectedForms.map((entry) => getFormName(entry));
                            const uniqueFormNames = Array.from(new Set(formNames));

                            if (uniqueFormNames.length === 1) {
                                const formName = uniqueFormNames[0] || "Unbekannt";
                                return (
                                    <span style={{ marginLeft: "10px" }}>(Typ: {formName})</span>
                                );
                            } else if (uniqueFormNames.length > 1) {
                                return (
                                    <span style={{ marginLeft: "10px" }}>
                                        (Formulartypen: {uniqueFormNames.join(", ")} – Positionen
                                        werden je Typ gruppiert)
                                    </span>
                                );
                            }
                            return null;
                        })()}
                    </Alert>
                )}
                <Content>
                    <Row style={{ paddingBottom: "20px" }}>
                        <Col>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                }}
                            >
                                <label
                                    style={{ minWidth: "20%", paddingTop: "6px" }}
                                    htmlFor={"date-from"}
                                >
                                    Von:
                                </label>
                                <input
                                    style={{ width: "auto" }}
                                    id={"date-from"}
                                    type={"date"}
                                    name={"created_at.gte"}
                                    className="form-control"
                                    onInput={(v) => {
                                        setInitialParameter(
                                            "form_entries.from",
                                            (v.target as any).value
                                        );
                                        setFrom((v.target as any).value);
                                    }}
                                    onChange={() => {}}
                                    value={from}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                }}
                            >
                                <label
                                    style={{ minWidth: "20%", paddingTop: "6px" }}
                                    htmlFor={"date-until"}
                                >
                                    Bis:
                                </label>
                                <input
                                    style={{ width: "auto" }}
                                    id={"date-until"}
                                    type={"date"}
                                    name={"created_at.lteq"}
                                    className="form-control"
                                    onInput={(v) => {
                                        setInitialParameter(
                                            "form_entries.until",
                                            (v.target as any).value
                                        );
                                        setUntil((v.target as any).value);
                                    }}
                                    onChange={() => {}}
                                    value={until}
                                />
                            </div>
                        </Col>
                        <Col>
                            <DeviceFilter
                                onSelect={(v) => {
                                    setInitialParameter("form_entries.devices", v);
                                    setDevices(v);
                                }}
                                value={devices}
                                isMulti
                                isSearchable
                            ></DeviceFilter>
                        </Col>
                        <Col>
                            <FormFilter
                                onSelect={(v) => {
                                    setInitialParameter("form_entries.forms", v);
                                    setForms(v);
                                }}
                                value={forms}
                                isMulti
                                isSearchable
                            />
                            <NotificationsFilter
                                onCheck={(e) => {
                                    const hasN = e.target.checked;
                                    setInitialParameter("form_entries.has_notifications", hasN);
                                    setHasNotifications(hasN);
                                }}
                                value={hasNotifications}
                            />
                        </Col>
                        <Col>
                            <StateFilter
                                onSelect={(v) => {
                                    setInitialParameter("form_entries.states", v);
                                    setStates(v);
                                }}
                                value={states}
                                isMulti
                                isSearchable
                            />
                        </Col>
                        <Col>
                            <CustomerFilter
                                onSelect={(v) => {
                                    setInitialParameter("form_entries.customers", v);
                                    setCustomers(v);
                                }}
                                value={customers}
                                isMulti
                                isSearchable
                            />
                            <EntityFilter
                                onSelect={(v) => {
                                    setInitialParameter("form_entries.entities", v);
                                    setEntities(v);
                                }}
                                optionsFilter={(entityOptions) => {
                                    if (isEmpty(customers)) {
                                        return entityOptions;
                                    }
                                    const customerIds = customers.map((c) => parseInt(c.value, 10));
                                    return entityOptions.filter((o) => {
                                        const entity = entitiesDB.autocomplete.find(
                                            (e) => e.id === o.value
                                        );
                                        return (
                                            entity &&
                                            customerIds.includes(parseInt(entity.customer_id, 10))
                                        );
                                    });
                                }}
                                value={entities}
                                isMulti
                                isSearchable
                            />
                        </Col>
                        <Col style={{ textAlign: "right" }}>
                            <Button onClick={resetFilter}>Filter zurücksetzen</Button>
                        </Col>
                    </Row>
                    {formEntries.isLoading && <Loader />}
                    {!formEntries.isLoading && formEntries.list.length > 0 && (
                        <div>
                            <div
                                style={{
                                    padding: "10px",
                                    backgroundColor: "#f8f9fa",
                                    marginBottom: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <Form.Check
                                    type="checkbox"
                                    checked={
                                        formEntries.list.length > 0 &&
                                        formEntries.list.every((entry) =>
                                            selectedEntryIds.includes(entry.id)
                                        )
                                    }
                                    onChange={handleSelectAll}
                                    label="Alle auswählen"
                                />
                                {selectedEntryIds.length > 0 && (
                                    <span className="text-muted">
                                        {selectedEntryIds.length} ausgewählt
                                    </span>
                                )}
                            </div>
                            {formEntries.list.map((entry) => {
                                return (
                                    <EntryRow
                                        entry={entry}
                                        key={entry.id}
                                        isSelected={selectedEntryIds.includes(entry.id)}
                                        onSelect={(isSelected) =>
                                            handleSelectEntry(entry.id, isSelected, entry)
                                        }
                                    />
                                );
                            })}
                        </div>
                    )}
                </Content>
            </div>

            {!formEntries.isLoading && formEntries.list.length === 0 && (
                <Content>
                    <EmptySpace
                        title={"Keine Protokolle gefunden."}
                        description={
                            "Übertrage ein ausgefülltes Formular mit einem iPad damit es hier erscheint."
                        }
                        cta={false}
                    />
                </Content>
            )}
            <div>
                <Centered>
                    <Pagination>
                        {pages().map((p) => {
                            return (
                                <Pagination.Item
                                    active={p === page}
                                    key={`page_${p}`}
                                    onClick={() => openPage(p)}
                                >
                                    {p}
                                </Pagination.Item>
                            );
                        })}
                    </Pagination>
                </Centered>
            </div>
        </>
    );
};

function mapStateToProps(state) {
    return { device: state.device, formEntries: state.formEntries };
}

export default withRouter(connect(mapStateToProps, actions)(AllEntriesPage));
